import { render, staticRenderFns } from "./CardGenerationRequestApproved.vue?vue&type=template&id=122c429f&"
import script from "./CardGenerationRequestApproved.vue?vue&type=script&lang=js&"
export * from "./CardGenerationRequestApproved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports